import { FC, useEffect } from 'react';
import { RowData } from '../../../DiagnosticsReport/SkillPerformanceByClassTable';
import { exportDiagnosticSkillsCsv } from '../../../../businessLogicService/downloadDiagnosticSkillsCsv';
import ExportToastHost from './ExportToastHost';
import { useExportToasts } from '../../../../businessLogicService/useExportToasts';

interface Props {
  start: number | null;
  rows: RowData[];
  loading: boolean;
  onDone?: () => void;
}

const ExportDiagnosticSkillsCsv: FC<Props> = ({ start, rows, loading, onDone }) => {
  const { downloadToastRef, successToastRef, progress, open, done, clear } = useExportToasts();

  useEffect(() => {
    if (!start) return;
    if (loading || !rows.length) return;

    open(1);
    try {
      setTimeout(() => exportDiagnosticSkillsCsv(rows), 0);
    } finally {
      done(() => onDone?.());
    }
  }, [start]);

  return (
    <ExportToastHost
      downloadToastRef={downloadToastRef}
      successToastRef={successToastRef}
      progress={progress}
      onClear={clear}
    />
  );
};

export default ExportDiagnosticSkillsCsv;
